import React, { FC, useMemo } from 'react'
import { IonModal, IonContent, IonHeader } from '@ionic/react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { each, orderBy, find, keyBy } from '@dt/fe-utils/dist/lodash'
import { storeMobx } from '@mobxStore'
import { MktEmpty } from '@cps'
import './index.scss'

interface IProps {
  storeList?: any[];
  showIds?: number[];
  reject?: () => void;
  resolve?(store?: IViewStore): void;
}

const StoreListModal: FC<IProps> = (props) => {
  const {
    storeList,
    showIds,
    resolve,
    reject
  } = props

  const handleAllStore = (storeIds: number[]) => {
    const list = []
    each(storeIds, (i: number) => {
      const findItem = find(storeMobx.viewStoreList, (item: any) => item.storeId === i)
      if (findItem) list.push(findItem)
    })
    return orderBy(list, 'distance') || []
  }
  const handleBuyMost = (store: any[]) => {
    const list = []
    each(storeMobx.storeBoughtList, (i: any) => {
      const findItem = find(store, (item: any) => item.storeId === parseFloat(i.storeId))
      if (findItem) list.push(i)
    })
    return orderBy(list, 'cnt', 'desc') || []
  }
  const showStoreList: any[] = useMemo(() => {
    if (storeList) {
      return storeList
    } else {
      const showList = showIds ? handleAllStore(showIds) : orderBy(storeMobx.viewStoreList, 'distance')
      if (showList.length) showList[0].isNearly = true
      const boughtList: any[] = handleBuyMost(showList)
      if (!boughtList.length) return showList
      const moreList = []
      const _boughtObj = keyBy(boughtList, 'storeId')
      showList.forEach(item => {
        const _item = _boughtObj[item.storeId]
        if (item.storeId === parseFloat(boughtList[0].storeId)) {
          moreList.unshift({
            ...item,
            boughtCnt: _item?.cnt || 0
          })
        } else {
          moreList.push({
            ...item,
            boughtCnt: _item?.cnt || 0
          })
        }
      })
      return moreList
    }
  }, [storeMobx.viewStoreList, storeMobx.storeBoughtList, storeList, showIds])
  return (
    <IonModal
      cssClass='store-list-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss
      onDidDismiss={reject}
    >
      <IonHeader className='modal-header'>
        <span><i className='iconfont icon-mendian1'></i>{i18n.t('mkt.giftCard.rechargeStore')}</span>
        <i className='iconfont icon-close' onClick={reject}></i>
      </IonHeader>
      <IonContent>
        {
          showStoreList.length
            ? (
              <div className='modal-body'>
                {
                  showStoreList.map(item => {
                    return (
                      <div key={item.storeId} className='store-item' onClick={() => resolve(item)}>
                        <div className='store-info'>
                          <div className='store-name'>
                            {!!item.boughtCnt && <span className='buy'>{i18n.t('store.boughtStoreByStore', { num: item.boughtCnt || 0 })}</span>}
                            <span>{item.storeName}</span>
                          </div>
                          <div className='store-address'>{item.address}{item.addressDetails}</div>
                        </div>
                        {
                          !!item.distanceWithUnit &&
                            <>
                              {
                                item.isNearly
                                  ? <div className='store-closest'>{i18n.t('store.storeClosest')} {item.distanceWithUnit}</div>
                                  : <div className='store-distance'><i className='iconfont icon-address'></i>{item.distanceWithUnit}</div>
                              }
                            </>
                        }
                      </div>
                    )
                  })
                }
              </div>
            ) : <MktEmpty text={i18n.t('decoration.noStore')}></MktEmpty>
        }
      </IonContent>
    </IonModal>
  )
}

export default observer(StoreListModal)
